module.exports = __webpack_public_path__ + "static/img/shl_small_baskeball_level_1.d0aac48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shl_small_baskeball_level_1.png
// module id = Cgl4
// module chunks = 5